export const environment = {
  production: false,
  type: 'beta',
  useMockDataFile: true,
  useMockDataServer: true,
  useMockInterceptor: false,
  appConfig: {
    clientRoot: 'https://unityexpress.beta.swbc.com',
    apiRoot: 'https://b-marketplace.swbc.com/api/v1',
    apiRootV2: 'https://b-marketplace.swbc.com/api/v2',
    proposalsApiRoot: 'https://unityexpress.beta.swbc.com/api/v1',
    identityRoot: 'https://b-portal.swbc.com/identity/connect',
    accountsApiRoot:
      'https://b-portal.swbc.com/api/accounts/getUserAccounts/Unity',
    vinApiRoot: 'https://b-vindata.swbc.com/api',
    clientApplicationId: '918ED21D-1B5C-4719-B30D-A7B826363572',
    UD_ClientApplicationId: '984BE096-F8D1-401B-968C-8B939E981584',
    headerURL: 'https://b-portal.swbc.com/cui/Header/Unity',
    tileImageSVGURL:
      'https://b-portal.swbc.com/Tile/GetTileImage?filename=79F83CD2616527218A8AE0E8069AFB5E.svg',
    dashBoardTilesUnity:
      'https://b-portal.swbc.com/DashboardTiles/WhatsNew/Unity',
    dashBoardTilesPortal:
      'https://b-portal.swbc.com/DashboardTiles/WhatsNew/Portal',
    tileImagePNGURL:
      'https://b-portal.swbc.com/Tile/GetTileImage?filename=default.png',
    localTokenPassword: '',
    localTokenEmail: '',
    helpEmail: 'MMP@swbc.com',
    idleTimeout: 720,
    timeout: 180,
    stsServer: 'https://b-portal.swbc.com/identity',
    responseType: 'id_token token',
    clientId: 'Unity',
    scope: 'openid Portal-privileges Unity-privileges profile email Unity',
    appDynamicsKey: 'AD-AAB-ABH-XEV',
    appDynamicsScriptURL: '//cdn.appdynamics.com/adrum/adrum-21.7.0.3493.js',
    isaSettingsURL: 'IntelligentSalesAssist/Settings',
    isaChatURL:
      'https://lg3ehey35jehuzvc56vy7lrqyi0bcuvx.lambda-url.us-east-1.on.aws',
    isaFeedbackURL:
      'https://vvqj057g6i.execute-api.us-east-1.amazonaws.com/prod/feedback',
    messagingScriptUrl:
      'https://swbc--uat.sandbox.my.site.com/ESWMessagingUnity1765475437379/assets/js/bootstrap.min.js',
    scrt2Url: 'https://swbc--uat.sandbox.my.salesforce-scrt.com',
    orgId: '00DOu00000ELoL7',
    messagingName: 'Messaging_Unity',
    messagingUrl:
      'https://swbc--uat.sandbox.my.site.com/ESWMessagingUnity1765475437379',
    admin: {
      clientApp: '/ClientApplication',
      clientAppCreateUpdate: '/ClientApplication/CreateUpdate',
      clientAppDelete: '/ClientApplication/Delete'
    },
    symitarRedirectURL:
      'https://b-unitynet.swbc.com/worksheet/SymitarPushExpress.aspx?Save=0&QuoteLoanId='
  }
};
